import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  withDefaults,
  watch,
  ref,
} from "vue";
import CommonHeader from "./components/common-header.vue";
import CommonFooter from "./components/common-footer.vue";
import CommonLeftMenu from "./components/common-left-menu.vue";
import { IMenuItem, IMenuMap } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    menus: null,
    activeRouteName: null,
    bannerImg: null,
    userName: null,
    userAvatar: null,
    hideHeaderComp: { type: Boolean, default: false },
    mainCoverAll: { type: Boolean, default: false },
    hideMsgBtn: { type: Boolean },
    hasUnReadMsg: { type: Boolean }
  },
  emits: ["menuClick", "logout", "showMessageListDrawer"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: "menuClick", menu: IMenuItem): void;
  (event: "logout"): void;
  (event: "showMessageListDrawer"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menus: IMenuItem[], activeRouteName: string, bannerImg?: string, userName?: string, userAvatar?: string, hideHeaderComp: boolean, mainCoverAll: boolean, hideMsgBtn?: boolean, hasUnReadMsg?: boolean }





// 用于强刷左侧路由
const menuCompRenderFlag = ref<boolean>(true);

// 生成所有末级路由的name映射到一级的map
const computedEndMenuNameToFirstMenuObj = computed<IMenuMap>(() => {
  const temp: IMenuMap = {};
  genMap(props.menus);
  return temp;

  function genMap(menus: IMenuItem[], topMenuItem?: IMenuItem) {
    for (let i = 0; i < menus.length; i++) {
      const mItem = menus[i];
      if (mItem.children && mItem.children.length > 0) {
        genMap(mItem.children, topMenuItem || mItem);
      } else {
        if (mItem.name && topMenuItem) {
          temp[mItem.name] = topMenuItem;
        }
      }
    }
  }
});

// 生成顶部菜单
const computedTopMenus = computed<IMenuItem[]>(() => {
  const tempMap: Map<IMenuItem, IMenuItem[]> = new Map();
  genMap(props.menus);
  const temp: IMenuItem[] = [];
  for (let [top, childrens] of tempMap) {
    const obj: IMenuItem = {
      title: top.title,
      icon: top.icon,
      name: top.name,
      children: childrens,
    };
    if (!obj.name) {
      delete obj.name;
    }
    if (!obj.children?.length) {
      delete obj.children;
    }
    temp.push(obj);
  }
  return temp;
  function genMap(menus: IMenuItem[], topMenuItem?: IMenuItem) {
    for (let i = 0; i < menus.length; i++) {
      const mItem = menus[i];
      if (mItem.children && mItem.children.length > 0) {
        genMap(mItem.children, topMenuItem || mItem);
      } else {
        if (topMenuItem) {
          if (!tempMap.get(topMenuItem)) {
            tempMap.set(topMenuItem, []);
          }
          tempMap.get(topMenuItem)?.push(mItem);
        } else {
          tempMap.set(mItem, []);
        }
      }
    }
  }
});

// 生成左侧菜单
const computedLeftMenuConfig = computed<IMenuItem | null>(() => {
  console.log(
    "生成左侧菜单:",
    computedEndMenuNameToFirstMenuObj.value,
    computedEndMenuNameToFirstMenuObj.value[props.activeRouteName]
  );
  return computedEndMenuNameToFirstMenuObj.value[props.activeRouteName] || null;
});

watch(
  () => props.activeRouteName,
  () => {
    console.log("监听到name变化：", props.activeRouteName);
  },
  {
    immediate: true,
  }
);

watch(
  () => props,
  () => {
    console.log("监听到props变化：", props);
  },
  {
    immediate: true,
    deep: true,
  }
);

// 主体区域样式
const computedLayoutMainContentWrapperStyle = computed(() => {
  return {
    "min-height": props.hideHeaderComp
      ? `calc(100vh - 456px)`
      : `calc(100vh - 456px - 270px - 48px)`,
    "margin-bottom": props.hideHeaderComp ? 0 : "24px",
  };
});

watch(
  () => computedLeftMenuConfig.value,
  (newVal, oldVal) => {
    console.log(
      "wacth menu change：",
      JSON.stringify(newVal) !== JSON.stringify(oldVal)
    );
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      menuCompRenderFlag.value = false;
      setTimeout(() => {
        menuCompRenderFlag.value = true;
      }, 0);
    }
  }
);

// 用户点击了菜单
function onMenuItemClick(menu: IMenuItem) {
  emits("menuClick", menu);
}
// 点击登出
function onLogout() {
  emits("logout");
}
// 点击消息弹出消息抽屉
function showMessageListDrawer() {
  emits("showMessageListDrawer");
}

return { __sfc: true,emits, props, menuCompRenderFlag, computedEndMenuNameToFirstMenuObj, computedTopMenus, computedLeftMenuConfig, computedLayoutMainContentWrapperStyle, onMenuItemClick, onLogout, showMessageListDrawer, CommonHeader, CommonFooter, CommonLeftMenu }
}

})